import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss'],
})
export class DatepickerComponent {

  @Input() title:string;
  @Input() locale:string;
  @Input() disabled:boolean;
  @Input() cancelText:string;
  @Input() doneText:string;
  @Input() value:any;
  @Input() presentation:any;
  @Input() subject:Subject<any>;

  minDate:any;
  maxDate:any;

  @Input() set min(value) {
    if(value) {
      this.minDate = value;
    }
  }

  @Input() set max(value) {
    if(value) {
      this.maxDate = value;
    }
  }

  constructor(private modal:ModalController) { 
    const now = new Date()
    now.setFullYear(new Date().getFullYear() - 5)
    this.minDate  = now.toISOString();

    now.setFullYear(new Date().getFullYear() + 5)
    this.maxDate = now.toISOString();
  }

  dismissModal() {
    this.modal.dismiss();
  }

  formatDate(date) {
    if(date) {
      if(this.presentation === "date") {
        date=date.substr(0,10);
      } else if (this.presentation === "time" && date.length > 10) {
        date=date.substr(11,5);
      }
    }

    this.subject.next(date);
    return date;
  }

}
